// extracted by mini-css-extract-plugin
export default {"input":"Style_input__pA20A"};